import React, { FC } from 'react';

const RssIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-23.000000, -19.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g transform="translate(23.000000, 19.000000)">
          <path
            d="M3.5677698,19.999341 C2.30142144,20.0238657 1.12062958,19.3623108 0.480269822,18.2695267 C-0.160089941,17.1767426 -0.160089941,15.8232574 0.480269822,14.7304733 C1.12062958,13.6376892 2.30142144,12.9761343 3.5677698,13.000659 C5.47399434,13.0375757 7,14.5934195 7,16.5 C7,18.4065805 5.47399434,19.9624243 3.5677698,19.999341 L3.5677698,19.999341 Z M0,10.2503047 L0,7 C7.17943189,7 13,12.8205681 13,20 L9.74969532,20 C9.74969532,14.615392 5.38460804,10.2503047 0,10.2503047 Z M0,3.33375 L0,1.08420217e-19 C11.04625,1.08420217e-19 20,8.95375 20,20 L16.66625,20 C16.66625,10.7954843 9.20451571,3.33375 0,3.33375 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default RssIcon;
